// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { CultureDto, ItemCultureRoutesDto } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useHeadlessCulturesResource () {

    /**
     * Get the culture associated with the given domain
     * @param url (optional) The full URL containing a domain
     * @return The found culture
     */
    function getCulture(
        url?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<string> {
        const computedUrl = computed( () => {
          let url_ = "/api/headless/culture?";

        const urlUnref = unref( url );
        if (urlUnref === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (urlUnref !== undefined)
            url_ += "url=" + encodeURIComponent("" + urlUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<string> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<string>( computedUrl, options_ );
    }

    /**
     * Method used to list all available cultures
     * @return The list of cultures
     */
    function listCultures(
        
    ) : UseApiFetchResponse<CultureDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/headless/cultures";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<CultureDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<CultureDto[]>( computedUrl, options_ );
    }

    /**
     * Retrieves the culture-specific routes for a content item identified by its ID
     * @param id The unique identifier of the content item
     * @return An ActionResult`1 containing the routes mapped by culture
    If the content item is not found, returns an empty ItemCultureRoutesDto
     */
    function listCultureRoutesById(
        id: MaybeRef<number>
    ) : UseApiFetchResponse<ItemCultureRoutesDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/headless/cultures/{id}/routes";

        const idUnref = unref( id );
        if (idUnref === undefined || idUnref === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idUnref));

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<ItemCultureRoutesDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<ItemCultureRoutesDto>( computedUrl, options_ );
    }

    /**
     * Retrieves a list of culture routes based on the specified path.
     * @param path (optional) The path to look up culture routes.
     * @return An asynchronous task that returns an ActionResult`1 containing 
    an ItemCultureRoutesDto if the operation is successful, 
    or an appropriate error result if it fails.
     */
    function listCultureRoutesByRoute(
        path?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<ItemCultureRoutesDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/headless/cultures/routes?";

        const pathUnref = unref( path );
        if (pathUnref === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (pathUnref !== undefined)
            url_ += "path=" + encodeURIComponent("" + pathUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<ItemCultureRoutesDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<ItemCultureRoutesDto>( computedUrl, options_ );
    }

    return {
        getCulture,
        listCultures,
        listCultureRoutesById,
        listCultureRoutesByRoute,
    }
}


export function $headlessCulturesResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Get the culture associated with the given domain
     * @param url (optional) The full URL containing a domain
     * @return The found culture
     */
    function getCulture(
        url?: string | undefined
    ) {
        let url_ = "/api/headless/culture?";

        const urlUnref = unref( url );
        if (urlUnref === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (urlUnref !== undefined)
            url_ += "url=" + encodeURIComponent("" + urlUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<string>( url_, options_, dependencies_ );
    }

    /**
     * Method used to list all available cultures
     * @return The list of cultures
     */
    function listCultures(
        
    ) {
        let url_ = "/api/headless/cultures";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<CultureDto[]>( url_, options_, dependencies_ );
    }

    /**
     * Retrieves the culture-specific routes for a content item identified by its ID
     * @param id The unique identifier of the content item
     * @return An ActionResult`1 containing the routes mapped by culture
    If the content item is not found, returns an empty ItemCultureRoutesDto
     */
    function listCultureRoutesById(
        id: number
    ) {
        let url_ = "/api/headless/cultures/{id}/routes";

        const idUnref = unref( id );
        if (idUnref === undefined || idUnref === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idUnref));

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<ItemCultureRoutesDto>( url_, options_, dependencies_ );
    }

    /**
     * Retrieves a list of culture routes based on the specified path.
     * @param path (optional) The path to look up culture routes.
     * @return An asynchronous task that returns an ActionResult`1 containing 
    an ItemCultureRoutesDto if the operation is successful, 
    or an appropriate error result if it fails.
     */
    function listCultureRoutesByRoute(
        path?: string | undefined
    ) {
        let url_ = "/api/headless/cultures/routes?";

        const pathUnref = unref( path );
        if (pathUnref === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (pathUnref !== undefined)
            url_ += "path=" + encodeURIComponent("" + pathUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<ItemCultureRoutesDto>( url_, options_, dependencies_ );
    }

    return {
        getCulture,
        listCultures,
        listCultureRoutesById,
        listCultureRoutesByRoute,
    }
}